<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicPartnerButtonDecorator from '~/components/form-elements/BasicPartnerButtonDecorator.vue'
import PartnerBox from '~/components/partner/PartnerBox.vue'
import PartnerSubtitle from '~/components/partner/PartnerSubtitle.vue'
import PartnerTable from '~/components/partner/PartnerTable.vue'
import PartnerTd from '~/components/partner/Table/PartnerTd.vue'
import PartnerTr from '~/components/partner/Table/PartnerTr.vue'
import Page from '~/enums/page'
import { useAuthStore } from '~/store/auth'
import { useUserStore } from '~/store/user'

const authStore = useAuthStore()
const userStore = useUserStore()

const buttonPage = computed(() => {
  if (!authStore.isUser) {
    return Page.PartnerLogin
  }

  if (!userStore.isSpecialist) {
    return Page.PartnerRegistration
  }

  return Page.Specialist
})
</script>

<template>
  <PartnerBox class="my-2 hidden lg:block">
    <PartnerSubtitle class="!mb-8" subtitle="Монетизировать свои знания и&nbsp;навыки с&nbsp;iTAB просто" />

    <PartnerTable>
      <PartnerTr>
        <PartnerTd class="lg:min-w-[260px]" is-head value="Способ заработка" />
        <PartnerTd class="rounded-tl-2xl font-medium" value="Консультации и&nbsp;сопровождение клиентов" />
        <PartnerTd class="font-medium" value="Подборки товаров" />
        <PartnerTd class="font-medium" value="Курсы и&nbsp;лекции" />
        <PartnerTd class="rounded-tr-2xl font-medium" value="Амбассадорство" />
      </PartnerTr>

      <PartnerTr>
        <PartnerTd is-head value="Что&nbsp;вы&nbsp;делаете" />
        <PartnerTd value="Проводите онлайн&nbsp;— или&nbsp;офлайн-консультации, рекомендуете продукты" />
        <PartnerTd value="Делитесь авторскими подборками с&nbsp;платформы" />
        <PartnerTd value="Встраиваете ссылки/продукты iTAB в&nbsp;курс или&nbsp;вебинар" />
        <PartnerTd value="Делаете обзоры, участвуете в&nbsp;мероприятиях, развиваете сеть" />
      </PartnerTr>

      <PartnerTr>
        <PartnerTd is-head value="Что&nbsp;получаете" />
        <PartnerTd class="rounded-bl-2xl" value="Гонорар за&nbsp;консультацию + до&nbsp;20% кешбэка с&nbsp;покупок клиента" />
        <PartnerTd value="Кешбэк до&nbsp;20% с&nbsp;каждой покупки" />
        <PartnerTd value="Кешбэк с&nbsp;заказов + продвижение от&nbsp;платформы" />
        <PartnerTd class="rounded-br-2xl" value="Вознаграждения, бонусы, доход с&nbsp;привлечённых партнёров" />
      </PartnerTr>
    </PartnerTable>

    <div class="mt-[30px] flex items-start">
      <!--      <PartnerLink class="mr-[100px]" title="Подробные условия" />-->

      <BasicPartnerButtonDecorator>
        <BasicButton
          class="
            mt-6 !h-[56px] !text-nowrap !px-8 !duration-300 hover:!bg-main-blue hover:!text-white md:mt-7 md:!w-min
          "
          color="white"
          :title="buttonPage === Page.Specialist ? 'Перейти в\xA0ЛК' : 'Cтать\xA0партнёром'"
          @click="navigateTo(buttonPage)"
        />
      </BasicPartnerButtonDecorator>
    </div>
  </PartnerBox>
</template>
